jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.timeline').length ) {
        const $ = jQuery;

        $('.timeline-slider').slick({
            vertical: true,
            verticalSwiping: true,
            variableHeight: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });
    }
});